import { gql } from 'graphql.macro';

export const UpdateOpportunity = gql`
    mutation updateOpportunity($request: UpdateOpportunityRequestModelInput) {
        updateOpportunity(request: $request)
    }
`;

export const CompleteOpportunity = gql`
    mutation CompleteOpportunity($request: CompleteOpportunityRequestModelInput) {
      completeOpportunity(request: $request)
    }
`;

export const ReopenOpportunity = gql`
mutation ReOpenOpportunity($nearMissId: Int!) {
  reopenOpportunity(nearMissId: $nearMissId)
}
`;

export const UpdateFile = gql`
  mutation updateFile($request: FileUpdateRequestInput) {
    updateFile(request: $request)
  }
`;

export const DeleteFile = gql`
  mutation deleteFile($referenceId: Uuid!, $fileId: Int!) {
    deleteFile(referenceId: $referenceId, fileId: $fileId)
  }
`;